const pageName = { singular: 'Kantor Operasional', plural: 'Kantor Operasional' }

export default [
  {
    path: '/operational-offices',
    name: 'operational-offices',
    component: () => import('@/views/pages/master-data/operational-office/Table.vue'),
    meta: {
      name: pageName,
      routeCreate: 'operational-offices-create',
      routeEdit: 'operational-offices-edit',
      resource: 'MasterData',
      action: 'manage',
      breadcrumb: [
        {
          text: 'Master Data',
        },
        {
          text: pageName.plural,
          active: true,
        },
      ],
    },
  },
  {
    path: '/operational-offices/create',
    name: 'operational-offices-create',
    component: () => import('@/views/pages/master-data/operational-office/Form.vue'),
    meta: {
      name: pageName,
      navActiveLink: 'operational-offices',
      resource: 'MasterData',
      action: 'manage',
      breadcrumb: [
        {
          text: 'Master Data',
        },
        {
          text: pageName.plural,
          route: 'operational-offices',
        },
        {
          text: 'Create',
          active: true,
        },
      ],
    },
  },
  {
    path: '/operational-offices/:id/edit',
    name: 'operational-offices-edit',
    component: () => import('@/views/pages/master-data/operational-office/Form.vue'),
    meta: {
      name: pageName,
      navActiveLink: 'operational-offices',
      resource: 'MasterData',
      action: 'manage',
      breadcrumb: [
        {
          text: 'Master Data',
        },
        {
          text: pageName.plural,
          route: 'operational-offices',
        },
        {
          text: 'Edit',
          active: true,
        },
      ],
    },
  },
]
